'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (style) {
    return prefixer.prefix(style);
};

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixer = new _inlineStylePrefixer2.default({
    userAgent: window.navigator.userAgent
}); /**
     * Created by ifchangetoclzp on 2016/11/11.
     */


//////////////////
// WEBPACK FOOTER
// ../~/candy-mobile/lib/fn/autoPrefixer.js
// module id = ../node_modules/candy-mobile/lib/fn/autoPrefixer.js
// module chunks = 7